<app-kpi-widget
  [title]="title"
  [icon]="'ph-duotone ph-hand-coins'"
  [isLoading]="isLoading"
  [totalValue]="value"
  [percentageDifference]="percentageDifference"
  [costDifference]="costDifference"
  [totalCost]="totalCost"
  [hasError]="hasError"
  [errorMessage]="errorMessage"
  [dropdownEnabled]="false"
  [isUptrendPositive]="true"
  [valueFormatter]="formatValue.bind(this)"
  [costFormatter]="formatCost.bind(this)"
  [costDifferenceFormatter]="formatCostDifference.bind(this)"
  [isImageIcon]="false"
></app-kpi-widget>